import { usePipeline } from '../../context/PipelineContext';
import { formatCurrency } from '../../utils/formatting';

const STAGE_OPACITY = [0.15, 0.30, 0.50, 0.70, 0.90];

export default function PipelineStageCards({ activeStageFilter, onStageFilterChange }) {
  const { stageSummary, pipelineKPIs, prospects } = usePipeline();
  const { closedWonCount, closedLostCount } = pipelineKPIs;

  const closedWonValue = prospects
    .filter(p => p.stage === 'closed-won')
    .reduce((sum, p) => {
      const ev = p.estimatedValue || {};
      return sum + (ev.oneTime || 0) + ((ev.monthlyRecurring || 0) * 12) + ((ev.aum || 0) * (ev.aumFeeRate || 0));
    }, 0);

  const unqualifiedCount = prospects.filter(p => p.stage === 'unqualified').length;

  return (
    <div>
      {/* Active stage cards - clickable to filter */}
      <div className="grid grid-cols-5 gap-4">
        {stageSummary.map((stage, idx) => {
          const isActive = activeStageFilter === stage.stageId;
          return (
            <button
              key={stage.stageId}
              onClick={() => onStageFilterChange(isActive ? null : stage.stageId)}
              className={`bg-white rounded-[4px] shadow-[0_2px_6px_rgba(0,0,0,0.07)] p-4 text-center border-t-[3px] transition-all cursor-pointer ${
                isActive
                  ? 'ring-2 ring-bullogic-blue/40 shadow-[0_4px_12px_rgba(0,0,0,0.12)]'
                  : 'hover:shadow-[0_4px_12px_rgba(0,0,0,0.1)]'
              }`}
              style={{ borderTopColor: `rgba(0, 109, 120, ${STAGE_OPACITY[idx]})` }}
            >
              <div className="text-[10px] font-bold uppercase tracking-[0.08em] text-deep-teal mb-2">
                {stage.label}
              </div>
              <div className="text-[32px] font-bold text-navy leading-tight">
                {stage.count}
              </div>
              <div className="text-[12px] font-light text-[#888] mt-1">
                {formatCurrency(stage.totalValue)}
              </div>
            </button>
          );
        })}
      </div>

      {/* Closed / Unqualified summary row */}
      <div className="mt-3 flex items-center justify-center gap-4 text-[12px] text-[#888]">
        <span>
          <span className="font-bold text-deep-teal">{closedWonCount}</span> Won ({formatCurrency(closedWonValue)})
        </span>
        <span className="text-[#ccc]">|</span>
        <span>
          <span className="font-bold text-rose">{closedLostCount}</span> Lost
        </span>
        {unqualifiedCount > 0 && (
          <>
            <span className="text-[#ccc]">|</span>
            <span>
              <span className="font-bold text-soft-coral">{unqualifiedCount}</span> Unqualified
            </span>
          </>
        )}
      </div>
    </div>
  );
}
